module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/hero/faces/116033.png";